import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import SelectCustom from '../../atoms/select/SelectCustom'
import StatusBtn from '../../atoms/status/StatusBtn'
import styles from './index.module.scss'
import {
	getVendorStaffEvents,
	updateVendorTask,
} from '../../../features/schedulerSlice'

const TaskList = ({ timelineEvents }) => {
	const dispatch = useDispatch()
	const status_options = [
		{
			value: 'new',
			label: (
				<StatusBtn
					label="New"
					variant="active"
					className={styles.statusOption}
				/>
			),
		},
		{
			value: 'inprogress',
			label: (
				<StatusBtn
					label="In Progress"
					variant="pending"
					className={styles.statusOption}
				/>
			),
		},
		{
			value: 'completed',
			label: (
				<StatusBtn
					label="Completed"
					variant="submitted"
					className={styles.statusOption}
				/>
			),
		},
		{
			value: 'overdue',
			label: (
				<StatusBtn
					label="Overdue"
					variant="closed"
					className={styles.statusOption}
				/>
			),
		},
	]

	const STATUS_LABEL = {
		new: 'New',
		inprogress: 'In Progress',
		completed: 'Completed',
		overdue: 'Overdue',
	}

	const uniqueEvents = useMemo(() => {
		const m = new Map()
		for (const e of timelineEvents) {
			if (!m.has(e._id)) m.set(e._id, e)
		}
		return Array.from(m.values())
	}, [timelineEvents])

	const tasksOnly = useMemo(() => uniqueEvents, [uniqueEvents])

	const normVal = (v) =>
		typeof v === 'string' ? v : (v?.value ?? v?.target?.value ?? '')

	const handleStatusChange = async (v, rowId) => {
		const statusKey = normVal(v)

		if (!rowId) return

		const task = tasksOnly.find((t) => String(t._id) === String(rowId))
		if (!task) return

		const statusLabel = STATUS_LABEL[statusKey] || 'New'

		const payload = { status: statusLabel }

		await dispatch(updateVendorTask({ id: rowId, data: payload })).unwrap()
		await dispatch(getVendorStaffEvents()).unwrap()
	}

	return (
		<ul className={styles.taskList}>
			{(timelineEvents?.length ? timelineEvents : [])
				?.slice(0, 5)
				.map((task, i) => (
					<li key={i} style={{ overflow: 'hidden' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								gap: '2px',
								fontSize: '14px',
								fontWeight: '600',
								color: '#313131',
							}}
						>
							<div
								style={{
									maxWidth: '100%',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
								}}
							>
								{task.Subject}
							</div>
							<span
								style={{
									fontSize: '12px',
									fontWeight: '400',
									color: '#8692A4',
									width: 'fit-content',
								}}
							>
								Due:{' '}
								{task.StartTime?.includes('T')
									? task.StartTime.split('T')[0]
									: task.StartTime}
							</span>
						</div>
						<div style={{ width: 'max-content', marginLeft: 'auto' }}>
							<SelectCustom
								options={status_options}
								defaultValue={task.status
									?.toLowerCase()
									?.replace(' ', '')}
								setDataFunction={(newStatus) =>
									handleStatusChange(newStatus, task._id)
								}
								label={
									status_options.find(
										(o) =>
											o.value ===
											task?.value
												?.toLowerCase()
												.replace(' ', '')
									)?.label
								}
								renderValueAsLabel={true}
							/>
						</div>
					</li>
				))}
		</ul>
	)
}

export default TaskList
